import { useDispatch, useSelector, useStore } from "react-redux";
import type { AppDispatch, AppStore, RootState } from "@/store/app/storeTypes";

/**
 * Typed hooks for Redux (Redux docs recommended pattern).
 * Use these instead of plain useDispatch/useSelector so dispatch knows about thunks
 * and selectors receive typed RootState.
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>();
